import SettlementsReport from "./SettlementsReport";

export default SettlementsReport;
